import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { GuardarAoiPayload } from "../../../shared/services/api/payload/terceros/GuardarAoiPayload";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Carga del AOI desde un KML/KMZ/ZIP ya subido (`FincasPlataformaService.GuardarAoi`, gRPC). */
export class GuardarAoiService {
  /** Reemplaza el AOI; el `clienteId` permite al servidor decir si un solape es con otra finca del mismo cliente. */
  static async guardar(payload: GuardarAoiPayload): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).guardarAoi({
      fincaId: payload.fincaId,
      blobUrl: payload.uriKml,
      clienteId: payload.clienteId,
    }));
  }
}
